import { IAnswerRepository } from "domain/contracts/answer.contracts";
import { Answer } from "domain/entities/answer";
import { Message } from "domain/entities/message";
import { httpClient } from "infra/axios/axios-api";

class AnswerRepository implements IAnswerRepository{
    async create(answers: Answer[]): Promise<Message<Answer[]>> {
        const returnedAnswers = await httpClient.post("answer", {data: answers});
        return returnedAnswers.data;
    }

    async getBySubmissionId(submissionId: string): Promise<Message<Answer[]>> {
        const response = await httpClient.get("/answer", {params: {submissionId}});
        return response.data;
    }
}

export default new AnswerRepository();
